<ng-container *ngIf="success; else error">
  <span
    *ngIf="titleFirst"
    [ngClass]="{ 'mapfre-fs-m mapfre-mt-sm': !smallTitle , 'mapfre-fs-s' : smallTitle}"
    class="medium-dark mapfre-mb-xsm"
    >{{ translation[i18 + '.RESULT.TITLE_OK'] }}</span
  >
  <img
    [src]="'assets/images/result/' + (imageOk || 'success') + '.svg'"
    alt="Resultado Ok"
  />
  <span *ngIf="!titleFirst" class="mapfre-fs-m medium-dark mapfre-mt-sm">{{
    translation[i18 + '.RESULT.TITLE_OK']
  }}</span>
  <span
    class="mapfre-fs-xs-r medium mapfre-mt-sm"
    [ngClass]="{ 'mapfre-mb-l': !subdescriptionEnabled }"
    [innerHTML]="translation[i18 + '.RESULT.DESCRIPTION_OK']"
  ></span>
  <ng-container *ngIf="subdescriptionEnabled">
    <mat-divider
      class="mapfre-mt-sm mapfre-mb-sm"
      style="width: 100%"
    ></mat-divider>
    <span
      class="mapfre-fs-xs-r medium mapfre-mb-l"
      [innerHTML]="translation[i18 + '.RESULT.SUB_DESCRIPTION_OK']"
    ></span>
  </ng-container>
</ng-container>

<ng-template #error>
  <span
    *ngIf="titleFirst"
    [ngClass]="{ 'mapfre-fs-m mapfre-mt-sm': !smallTitle , 'mapfre-fs-s' : smallTitle}"
    class="medium-dark mapfre-mb-xsm"
    >{{ translation[i18 + '.RESULT.TITLE_KO'] }}</span
  >
  <img
    [src]="'assets/images/result/' + (imageKo || 'error') + '.svg'"
    alt="Resultado Error"
  />
  <span *ngIf="!titleFirst" class="mapfre-fs-m medium-dark mapfre-mt-sm">{{
    translation[i18 + '.RESULT.TITLE_KO']
  }}</span>
  <span
    class="mapfre-fs-xs-r medium mapfre-mt-sm mapfre-mb-l"
    [ngClass]="{ 'mapfre-mb-l': !subdescriptionEnabled }"
    [innerHTML]="resultDescriptionKoInnerHtml"
  ></span>
  <ng-container *ngIf="subdescriptionEnabled">
    <mat-divider
      class="mapfre-mt-sm mapfre-mb-sm"
      style="width: 100%"
    ></mat-divider>
    <span
      class="mapfre-fs-xs-r medium mapfre-mb-l"
      [innerHTML]="translation[i18 + '.RESULT.SUB_DESCRIPTION_KO']"
    ></span>
  </ng-container>
</ng-template>

<a *ngIf="linkI18" class="link mapfre-mb-m" (click)="onLink()">
  {{ linkI18 | translate }}
</a>

<div
  *ngIf="!hideBtns"
  class="buttons"
  [ngClass]="{ 'mapfre-show-mobile': whiteBoxMode }"
>
  <ion-button *ngIf="showOkButton"
    [fill]="onlyOkButton ? undefined : 'clear'"
    [color]="onlyOkButton ? 'primary' : 'dark'"
    (click)="onOkBtn()"
  >
    {{ translation[i18 + '.RESULT.BUTTON_CONFIRM_' + (success ? 'OK' : 'KO')] }}
  </ion-button>
  <ion-button *ngIf="!onlyOkButton" (click)="onBackBtn()">
    {{ translation[i18 + '.RESULT.BUTTON_BACK'] }}
  </ion-button>
</div>
